export default {"src":"/_next/static/media/404-error.a98116ba.svg","height":311,"width":585,"blurWidth":0,"blurHeight":0};